<template>
  <div id="mapContainer">
    <div ref="map" id="map"></div>
    <div id="marker"></div>
    <div v-for="(item, i) in pois" :key="i" :ref="'marker'+ i"></div>
  </div>
</template>

<script>
/* eslint-disable*/
import L from 'leaflet'

let currentKey = 0;
const COMMENTS_API_URL = 'https://www.bordeaux-phototour.com/api/comments';

export default {

  name: 'LeafletMap',
  props: {
    isReal: Number,
    simulatedPosition: Object
  },

  data() {
    return {
      watchId: undefined,
      updatePosition: [this.updateSimulated, this.updateReal],
      map: undefined,
      marker: undefined,
      data: [[], []],
      pois: [],
      oldLocation: {}
    };
  },

  watch: {
    'simulatedPosition.lat'(){
      this.updateSimulated();
    },
    'simulatedPosition.lon'(){
      this.updateSimulated();
    },
    data(val) {
      let self = this;

      this.getPois()
      .then(() => {
        self.addImages();
      })
      .catch(e => console.log(e));
    }
  },

  mounted () {

    let mapId = this.$refs.map.id;

    let isReal = this.isReal;
    let updatePosition = this.updatePosition
    navigator.geolocation.getCurrentPosition(function (position) {
      
      let newLatLon = new mapboxgl.LngLat(position.coords.longitude, position.coords.latitude);

      mapboxgl.accessToken = 'pk.eyJ1IjoicG1jb20iLCJhIjoiY2lxajgxbHF3MDBjZWkwbWMza2pwYzFoayJ9.a1ywamqhc2BKAdxMdgcBpA';
      vm.map = new mapboxgl.Map({
        container: mapId, // container id
        style: 'mapbox://styles/pmcom/cjzy4421417c61cnyldipyd0n', //hosted style id
        center: newLatLon, // starting position
        zoom: 13, // starting zoom
        maxZoom: 18
      });

      let el = document.getElementById('marker')

      vm.marker = new mapboxgl.Marker({
        element: el,
        anchor: 'bottom'
      });
      vm.marker.setLngLat(newLatLon).addTo(vm.map);
      vm.map.setCenter(newLatLon);
      
      updatePosition[isReal]();

    });

  },

  methods: {

    addTours(tours) {

      let baseWidth = 5;
      let baseZoom = 15;

      let paintSettings = [{
        'line-color': '#9a312b',
        'line-width': 5
      }, {
        'line-color': '#9a312b',
        'line-width': {
            'type': 'exponential',
            'base': 2,
            'stops': [
                [0, baseWidth * Math.pow(2, (0 - baseZoom))],
                [22, baseWidth * Math.pow(2, (22 - baseZoom))]
            ]
        },
        "line-dasharray": [5, 5]
      }];

      for (let i = 0; i < tours.length; i++) {
        let current = tours[i];

        vm.map.addLayer({
          id: 'tour'+ i,
          type: 'line',
          source: {
            type: 'geojson',
            data: {
              type: 'Feature',
              properties: {},
              geometry: current.geometry
            }
          },
          layout: {
            'line-join': 'round',
            'line-cap': 'round'
          },
          paint: paintSettings[i]
        });
      }


    },
    addImages(){

      for (let i = 0; i < this.pois.length; i++) {
        let current = this.pois[i];

        let el = this.$refs['marker'+ i][0];
        el.className = 'marker';

        if (current.images.length > 0) {
          el.style.backgroundImage = 'url("https://www.bordeaux-phototour.com/images/'+ current.images[0].image_dir +'/'+ current.images[0].file +'")';
        }
        el.style.width = '60px';
        el.style.height = '60px';

        new mapboxgl.Marker(el).setLngLat([current.lng, current.lat]).addTo(vm.map);

        vm.map.addSource('polygon'+ i, this.createGeoJSONCircle([Number(current.lng), Number(current.lat)], current.radius / 1000));

        vm.map.addLayer({
            'id': 'polygon'+ i,
            'type': 'fill',
            'source': 'polygon'+ i,
            'layout': {},
            'paint': {
                'fill-color': 'blue',
                'fill-opacity': 0.6
            }
        });

      }
      
    },
    updateReal(){

      let self = this;

      if (vm.watchId !== undefined) {
        navigator.geolocation.clearWatch(vm.watchId);
      }

      navigator.geolocation.getCurrentPosition(function (position) {

        let newLatLon = new mapboxgl.LngLat(position.coords.longitude, position.coords.latitude);
        vm.marker.setLngLat(newLatLon);
        vm.map.setCenter(newLatLon);

        self.oldLocation = {lon: position.coords.longitude, lat: position.coords.latitude};

        fetch(COMMENTS_API_URL +'/circuits', {
          cache: 'force-cache'
        })
        .then(r => r.json())
        .then((r) => {

          for (let i = 0; i < r.data.length; i++) {
            
            let current = r.data[i];

            self.data[1].push(JSON.parse(current.geojson));

          }

          setTimeout(function() {
            self.addTours(self.data[1]);
          }, 1000);

        })
        .catch(e => console.error(e));

        let heading = 0;
        
        vm.watchId = navigator.geolocation.watchPosition(function (position) {
          
          let newLatLon = new mapboxgl.LngLat(position.coords.longitude, position.coords.latitude);
          vm.marker.setLngLat(newLatLon);
          vm.map.setCenter(newLatLon);

          setTimeout(() => {
            heading = (position.coords.heading !== null)? position.coords.heading : heading;
            vm.map.rotateTo(heading);
          }, 0);

          self.$emit('realupdate', position);

        },
        (err) => {console.error(err.code +'\n'+ err.message);}, {
            enableHighAccuracy: true,
            timeout: 5000,
            maximumAge: 0
        });

      },
      (err) => {console.error(err.code +'\n'+ err.message);}, {
          enableHighAccuracy: true,
          timeout: 5000,
          maximumAge: 0
      });
    },
    updateSimulated() {
      let newLatLon = new mapboxgl.LngLat(this.simulatedPosition.lon, this.simulatedPosition.lat);
      vm.marker.setLngLat(newLatLon);
      vm.map.setCenter(newLatLon);
      this.addTours(this.data[1]);
      this.addImages();
    },
    createGeoJSONCircle(center, radiusInKm, points) {

        if(!points) points = 64;

        var coords = {
            latitude: center[1],
            longitude: center[0]
        };

        var km = radiusInKm;

        var ret = [];
        var distanceX = km/(111.320*Math.cos(coords.latitude*Math.PI/180));
        var distanceY = km/110.574;

        var theta, x, y;
        for(var i=0; i<points; i++) {
            theta = (i/points)*(2*Math.PI);
            x = distanceX*Math.cos(theta);
            y = distanceY*Math.sin(theta);

            ret.push([coords.longitude+x, coords.latitude+y]);
        }
        ret.push(ret[0]);

        return {
            "type": "geojson",
            "data": {
                "type": "FeatureCollection",
                "features": [{
                    "type": "Feature",
                    "geometry": {
                        "type": "Polygon",
                        "coordinates": [ret]
                    }
                }]
            }
        };
    },
    getPois() {

      let self = this;

      return fetch(COMMENTS_API_URL +'/pois')
      .then(r => r.json())
      .then((r) => {

        let data = (r.requestStatus && r.requestStatus.status == 'ok')? r.data : [];

        self.pois = data;
        self.$emit('pois-ready', data);

      });

    },
    math_rad2deg(v) {
      return v * (180 / Math.PI);
    },
    math_haversine(lonFrom, latFrom, lonTo, latTo) {
        let earth_radius = 6371000;
        
        let dLat = this.math_deg2rad(latTo - latFrom);
        let dLon = this.math_deg2rad(lonTo - lonFrom);
        
        let a = Math.sin(dLat/2) * Math.sin(dLat/2) + Math.cos(this.math_deg2rad(latFrom)) * Math.cos(this.math_deg2rad(latTo)) * Math.sin(dLon/2) * Math.sin(dLon/2);
        let c = 2 * Math.asin(Math.sqrt(a));
        let d = earth_radius * c;
        
        return Math.round(d);
    },
    math_deg2rad(v) {
      return v * (Math.PI / 180);
    }
    
  },
  
}
</script>

<style scoped>
#map {
  height: 100%;
  width: 100%;
  grid-column: 1;
  grid-row: 1;
}

#mapContainer
{
  grid-row: 3;
}

#marker {
  background-image: url('../assets/images/icon.png');
  background-size: cover;
  width: 50px;
  height: 50px;
  border-radius: 50%;
  z-index: 1000;
}

.marker
{
  background-size: 60px 100%;
  border: 3px solid white;
  border-radius: 50%;
}


</style>
